import React from 'react';
import { CircleProgress } from 'shared/components/ui/circle-progress';
import { DeadlineChip } from 'shared/components/ui/deadline-chip';
import { TimeslotTitle } from 'shared/components/ui/timeslot-title';
import { Timestamp } from 'shared/types/timestamp';
import { useTheme } from 'styled-components';

import * as Styled from './goal-row.style';

export type GoalRowProps = {
  name: string;
  deadline?: Timestamp | null;
  completionPercentage?: number;
  color?: string | null;
  completed?: boolean;
  selected?: boolean;
  onClick?: () => void;
  onContextMenu?: (event: React.MouseEvent) => void;
};

export const GoalRow: React.FC<GoalRowProps> = ({
  name,
  deadline,
  completionPercentage,
  color,
  completed,
  selected,
  onClick,
  onContextMenu,
}) => {
  const theme = useTheme();

  return (
    <Styled.Container
      type="button"
      $selected={!!selected}
      onClick={onClick}
      onContextMenu={onContextMenu}
    >
      <Styled.TitleArea $completed={!!completed}>
        <TimeslotTitle
          title={name}
          color={color ?? theme.palette.grey[600]}
          icon={
            <CircleProgress
              percentage={completionPercentage}
              hidePercentage
              isSmall
            />
          }
          showChevron
        />
      </Styled.TitleArea>

      {!!deadline && (
        <DeadlineChip date={deadline} isShort isCompleted={!!completed} />
      )}
    </Styled.Container>
  );
};
